// extracted by mini-css-extract-plugin
export default {"update-saved-bills":"update-saved-bills_update-saved-bills__gmEvy"};